/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";

Vue.use(Vuesax);

// Filters
import "./filters/filters.js";

// Theme Configurations
import "../themeConfig.js";

// Vue Router
import router from "./router";

// Axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// API Endpoints
import endpoints from "./network/endpoints";
Vue.prototype.$endpoints = endpoints;

// HTTP Error code
import http_codes from "./network/http_codes";

// Vuex Store
import store from "./store/store";

// Globally Registered Components
import "./globalComponents.js";

// Vue Localization
import { i18n } from "./i18n.js";
import enMessage from "./locales/en";
import idMessage from "./locales/id";

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    en: { attributes: enMessage.attribute },
    id: { attributes: idMessage.attribute },
  },
});

// Global Methods
import global from "./helper/global";
Vue.mixin({
  methods: global,
});

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// Moment
import moment from "moment-timezone";
Vue.use(moment);
moment.tz.setDefault(store.getters.getUserCountry ? store.getters.getUserCountry.timezone_name : "Asia/Singapore");

// Socket.io

let io = require("socket.io-client");
window.socket = io.connect(process.env.MIX_SOCKETIO_HOSTNAME, {
  transports: ["websocket", "polling", "flashsocket"],
  path: "/socket.io",
});

// Vue.prototype.$socketio = socket;

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: process.env.MIX_GOOGLE_API_KEY,
    libraries: "places, directions", // This is required if you use the Auto complete plug-in
  },
});

// Vue Telephone Input
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
Vue.use(VueTelInput);

// Image Viewer
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Sentry
import * as Sentry from "@sentry/vue";
if (process.env.MIX_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.MIX_SENTRY_DSN,
    maxBreadcrumbs: 10,
    release: process.env.MIX_SENTRY_RELEASE,
    environment: process.env.MIX_SENTRY_ENVIRONMENT,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  i18n,

  mounted: function() {
    store.dispatch("updateTheme", store.getters.isDarkMode ? "dark" : "light");
  },
}).$mount("#app");
